export default __webpack_public_path__ + "static/how-hometown-works-icon-1-eba99a22af68eac29e2f4e57a53147e4.png";